export const lettersSpacesRegExp = /^[A-Za-z ]+$/;
